export const career1 = require('./Career1.jpg');
export const career2 = require('./Career2.jpg');
export const career3 = require('./Career3.jpg');
export const career4 = require('./Career4.jpg');
export const careerHero = require('./careerHero.mp4')